<!-- <p>poll-result-dialog works!</p> -->
<div
  class=""
  [ngClass]="{
    'poll-result-container':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'poll-result-container-mobile': screenSize == ScreenType.Mobile
  }"
>
  <div class="mat-dialog-header">
    <h1 mat-dialog-title>Poll Result</h1>
  </div>
  <mat-dialog-content class="mat-typography">
    <div class="tickets-dialog-options">
      <div class="form-fields-container">
        <div class="poll-title">
          {{ data.pollTitle }}
        </div>
        <mat-divider></mat-divider>
        <div
          *ngFor="let poll of pollResults; let i = index"
          class="poll-response"
        >
          <div style="display: flex; align-items: center">
            <span class="bullet">&#9679;</span> {{ poll.Option }}
          </div>
          <div>
            <b>{{ getResult(poll) }}</b>
          </div>
        </div>
      </div>
    </div>
  </mat-dialog-content>
  <mat-dialog-actions>
    <button mat-raised-button mat-dialog-close>Close</button>
    <!-- <button
      mat-raised-button
      [mat-dialog-close]="[{ response: choosedResponse, pollId: data.pollId }]"
    >
      Submit
    </button> -->
  </mat-dialog-actions>
</div>
